/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import CustomerImportsIcon from 'icons/CustomerImportsIcon';

const messages = defineMessages({
  title: {id: 'navigation.data-integrations.customer-imports'},
});

const CustomerImportsItem = () => (
  <RouteLinkItem
    iconBefore={CustomerImportsIcon}
    route="midas/data-integrations/customer-imports"
    title={messages.title}
  />
);

export default CustomerImportsItem;
